import styled from 'styled-components';

const TopExplain = styled.div`
  font-size: 18px;
  line-height: 1.5;
  white-space: break-spaces;
`;

export default TopExplain;
